import React from 'react';

/**
 * Clean Ceruleo landing page with centered logo
 */
export default function CeruleoLandingPage() {
  return (
    <div 
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center'
      }}
    >
      <a 
        href="https://ceruleo.io" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{
          textDecoration: 'none'
        }}
        onMouseEnter={(e) => {
          const img = e.currentTarget.querySelector('img');
          if (img) img.style.opacity = '0.8';
        }}
        onMouseLeave={(e) => {
          const img = e.currentTarget.querySelector('img');
          if (img) img.style.opacity = '1';
        }}
      >
        <img 
          src="/favicon.ico" 
          alt="Ceruleo" 
          style={{
            width: '150px',
            height: '150px',
            objectFit: 'contain',
            backgroundColor: 'transparent',
            borderRadius: '12px',
            marginBottom: '20px',
            transition: 'opacity 0.3s ease'
          }}
        />
      </a>
      <p
        style={{
          marginTop: '40px',
          fontSize: '14px',
          color: '#888',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }}
      >
        Powered by ShapeDiver
      </p>
    </div>
  );
}